import { render, staticRenderFns } from "./SelectorZonaComponent.vue?vue&type=template&id=a1ba0ed8"
import script from "./SelectorZonaComponent.vue?vue&type=script&lang=js"
export * from "./SelectorZonaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports